import type { FgaUser } from '@/generated/model';

import { getLanguageCode } from './languageUtils';

const surnameFirstLanguages = new Set(['hu']);

export function getUserDisplayName(user: Pick<FgaUser, 'firstName' | 'surname' | 'name'>, language?: string) {
  const languageCode = getLanguageCode(language);
  const nameParts = surnameFirstLanguages.has(languageCode)
    ? [user.surname, user.firstName]
    : [user.firstName, user.surname];
  const displayName = nameParts.filter((namePart): namePart is string => !!namePart).join(' ');

  return displayName || user.name;
}
